import React from "react";
import { useT } from "@/lib/LanguageContext";
import { OFFSET_UNIT_KEYS, OFFSET_UNIT_SINGULAR_KEYS, OFFSET_ANCHOR_KEYS } from "../../contract";
import { CRM } from "../../../../constants/testIds/crm";

/** "{value} {unit} {anchor}" pluralised by value ("1 hour before session", "24 hours before session"). */
export const offsetText = (offset, t) => {
  if (!offset) return "";
  const unitKey = offset.value === 1 ? OFFSET_UNIT_SINGULAR_KEYS[offset.unit] : OFFSET_UNIT_KEYS[offset.unit];
  return `${offset.value} ${t(unitKey)} ${t(OFFSET_ANCHOR_KEYS[offset.anchor])}`;
};

/** The collapsed row of a step not currently open (spec: "Step 2 · 1 hour before session · …"). */
export default function StepSummary({ step, index, onOpen }) {
  const t = useT("crm");
  const excerpt = (step.subject || "").trim();
  return (
    <button type="button" onClick={onOpen} data-testid={CRM.seqStepSummary(index)}
      className="w-full rounded-2xl border border-eh-border-soft bg-white px-4 py-3 text-left text-sm text-eh-ink hover:bg-eh-bg">
      {excerpt
        ? t("seq.stepSummary", { n: index + 1, offset: offsetText(step.offset, t), excerpt })
        : t("seq.stepSummaryNoBody", { n: index + 1, offset: offsetText(step.offset, t) })}
    </button>
  );
}
